import React, { useEffect, useState } from "react";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import ListLayout from "../../../../../partials/content/ListLayout";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import AssetBasicInfo from "./assetBasicInfo";
import AssetDepreciations from "./assetDepreciations";
import AssetDisposals from "./assetDisposals";
import AssetForm from "../assetForm/assetForm";
import DisposalAssetForm from "../disposalAssetForm/disposalAssetForm";
import { getAssetDetail } from "../../../../../services/finance/finance";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const AssetDetail = ({ match, history }) => {
  const { reload } = useGlobalData();
  const assetStockID = match.params.assetID;
  const [assetStock, setAssetStock] = useState({ itemName: "" });
  const [batch, setBatch] = useState(null);
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [openAssetForm, setOpenAssetForm] = useState(false);
  const [openDisposalAssetForm, setOpenDisposalAssetForm] = useState(false);
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "assetDepreciations",
      label: "Asset Depreciations",
      icon: "fas fa-car",
    },
    {
      key: "assetDisposals",
      label: "Asset Disposals",
      icon: "fas fa-store-alt-slash",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getAssetDetailData();
  }, [assetStockID, reload]);

  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/finance/assets");
      },
    },
  ];
  if (assetStock.disposalStatus !== 3) {
    actionButtons.push({
      title: "Edit Asset",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        setOpenAssetForm(true);
      },
    });
    actionButtons.push({
      title: "Dispose Asset",
      color: "danger",
      icon: "fas fa-trash-alt",
      onClick: () => {
        setOpenDisposalAssetForm(true);
      },
    });
  }
  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/assets",
            title: "Assets",
            active: false,
          },
          {
            page: "/finance/asset-detail/" + assetStockID,
            title: "Asset ID " + assetStockID + " " + assetStock.itemName,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <AssetBasicInfo assetStock={assetStock} batch={batch} />
                );
                setHeaderTitle("Basic Info");
                break;
              case "assetDepreciations":
                selectedComponent = (
                  <AssetDepreciations
                    assetDepreciations={assetStock.assetDepPeriod}
                    onRefresh={() => {
                      getAssetDetailData();
                    }}
                  />
                );
                setHeaderTitle("Asset Depreciations");
                break;
              case "assetDisposals":
                selectedComponent = (
                  <AssetDisposals
                    assetDisposals={assetStock.assetDisposal}
                    onRefresh={() => {
                      getAssetDetailData();
                    }}
                  />
                );
                setHeaderTitle("Asset Disposals");
                break;
              default:
                selectedComponent = (
                  <AssetBasicInfo assetStock={assetStock} batch={batch} />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
      <DialogLayout
        open={openDisposalAssetForm}
        title="Disposal Asset Form"
        onCloseDialog={() => {
          setOpenDisposalAssetForm(false);
        }}
        maxWIdth="lg"
      >
        <DisposalAssetForm
          assetStockID={assetStockID}
          onCloseDialog={() => {
            setOpenDisposalAssetForm(false);
          }}
          onConfirmSave={() => {
            getAssetDetailData();
            setOpenDisposalAssetForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openAssetForm}
        title="Asset Form"
        onCloseDialog={() => {
          setOpenAssetForm(false);
        }}
        maxWIdth="lg"
      >
        <AssetForm
          assetStockID={assetStockID}
          onConfirmSave={() => {
            getAssetDetailData();
            setOpenAssetForm(false);
          }}
          onCloseDialog={() => {
            setOpenAssetForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  async function getAssetDetailData() {
    const response = await getAssetDetail(assetStockID);
    const { data } = response.data;
    const componentTmp = (
      <AssetBasicInfo assetStock={data.assetStock} batch={data.batch} />
    );
    setAssetStock(data.assetStock);
    setBatch(data.batch);
    setComponent(componentTmp);
  }
};

export default AssetDetail;
